import React from "react";
import { Link } from "react-router-dom";
import { useCustomerAuth } from "@/context/CustomerAuthContext";
import PublicLayout from "@/components/public/PublicLayout";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { VETERAN } from "@/constants/testIds";
import { BadgeCheck, Percent, Watch, Headset, Gift } from "lucide-react";

const PERKS = [
  { icon: Percent, title: "Standing 10% benefit", body: "Your verified discount is applied automatically at checkout — no codes to remember." },
  { icon: Watch, title: "Early access to drops", body: "Preview select private inventory before it reaches the public collection." },
  { icon: Headset, title: "Priority concierge", body: "A dedicated line for sourcing requests and authentication questions." },
  { icon: Gift, title: "Service milestones", body: "Occasional thank-you gifts and invitations reserved for the Circle." },
];

export default function VeteransCircle() {
  const { customer } = useCustomerAuth();

  return (
    <PublicLayout>
      <section className="max-w-5xl mx-auto px-5 py-16" data-testid={VETERAN.page}>
        <div className="flex items-center gap-2 mb-3">
          <Badge variant="outline" className="bg-[var(--panel-2)] text-[#c9a86a] border-[#c9a86a] gap-1.5">
            <BadgeCheck size={13} /> Verified Veteran
          </Badge>
        </div>
        <div className="text-[#c9a86a] tracking-[0.3em] text-xs mb-2">VETERANS&rsquo; CIRCLE</div>
        <h1 className="text-3xl md:text-4xl font-semibold text-[var(--text)]">
          Thank you for your service, {customer?.name?.split(" ")[0] || "friend"}.
        </h1>
        <p className="text-[var(--text-2)] mt-3 max-w-2xl">
          This is your private corner of the house. Your ID.me verification stays on file, so your benefits
          follow you automatically across the collection and checkout.
        </p>

        <div className="grid sm:grid-cols-2 gap-5 mt-10">
          {PERKS.map((p) => (
            <div key={p.title} className="border border-[var(--border-lch)] bg-[var(--panel)] rounded-xl p-6">
              <p.icon size={20} className="text-[#c9a86a] mb-3" />
              <div className="text-[var(--text)] font-medium mb-1">{p.title}</div>
              <p className="text-sm text-[var(--text-2)]">{p.body}</p>
            </div>
          ))}
        </div>

        <div className="mt-10 flex flex-wrap items-center gap-3">
          <Link to="/watches">
            <Button className="bg-[#c9a86a] hover:bg-[#b89455] text-[var(--on-gold)] font-semibold rounded-none" data-testid="veterans-browse-btn">
              Browse the collection
            </Button>
          </Link>
          <Link to="/shop">
            <Button variant="outline" className="border-[var(--border-2)] text-[var(--text)] hover:bg-[var(--panel-2)] rounded-none">
              Visit the shop
            </Button>
          </Link>
        </div>
      </section>
    </PublicLayout>
  );
}
